import React from 'react';

export default function Copyright() {
  return (
    <div className="copyright">
      <p>© 2019 What to watch Ltd.</p>
    </div>
  );
}
